export const calculateWinner = (squares) => {
  const lines = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6],
  ];
  for (let i = 0; i < lines.length; i++) {
    const [a, b, c] = lines[i];
    if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
      return squares[a];
    }
  }
  let count = 0;
  for (let i = 0; i < squares.length; i++) {
    if (squares[i]) {
      count++;
    }
  }
  if (count === squares.length) return 'Tie';
  return null;
};

export const calculateNextValue = (squares) => {
  return squares.filter(Boolean).length % 2 === 0 ? 'X' : 'O';
};

export const calculateStatus = (winner, squares, nextValue) => {
  return winner
    ? `Winner: ${winner}`
    : squares.every(Boolean)
    ? `Scratch: Cat's game`
    : `Next player: ${nextValue}`;
};
